import http from './axiosConfig' //引入基础配置
import { newBaseUrl as baseUrl } from "./api";
let getData = {}
//设置峰平谷--电价---周
  getData.electicprice= (data)=>{
    return http.post(baseUrl+"/one/electicprice/",data)
  }
  //查询峰平谷电价--电价---周
  getData.selectelectricprice= (data)=>{ 
    return http.post(baseUrl+"/one/selectelectricprice/",data)
  }
  //修改--电价---周
  getData.modifyelectricprice= (data)=>{
    return http.post(baseUrl+"/one/modifyelectricprice/",data)
  }
  //实时负荷 测试p_id用34  项目id p_id 用户id user_id
  getData.powerload= (data)=>{ 
    return http.get(baseUrl+"/one/powerload/",{ params:data })
  }
  //用电实时负荷 测试p_id用34  项目id p_id 用户id user_id
  getData.electricitypowerload= (data)=>{ 
    return http.get(baseUrl+"/one/electricitypowerload/",{ params:data })
  }
  //左屏 -- 安全运行天数 -- 周
  getData.usetime= (data)=>{ 
    return http.get(baseUrl+"/one/usetime/",{ params:data })
  }
  //左屏 -- 日月年电量 + 峰平谷电价 -- 周
  getData.daymonthyearelectricity= (data)=>{ 
    return http.get(baseUrl+"/one/daymonthyearelectricity/",{ params:data })
  }
  //左屏 -- 较昨日发电负荷同期比 -- 周
  getData.compareyesterday= (data)=>{ 
    return http.get(baseUrl+"/one/compareyesterday/",{ params:data })
  }
  //左屏 -- 环保指标 -- 周
  getData.environmentdata= (data)=>{ 
    return http.get(baseUrl+"/one/environmentdata/",{ params:data })
  }
  //左屏 -- 厂用电率 -- 李
  getData.electricusedrate= (data)=>{ 
    return http.get(baseUrl+"/one/electricusedrate/",{ params:data })
  }
  //左屏 -- 左屏热耗率 -- 范
  getData.heatconsumptionrate= (data)=>{ 
    return http.get(baseUrl+"/one/heatconsumptionrate/",{ params:data })
  }
  //左屏 -- Nox排放浓度 -- 李
  getData.nox= (data)=>{ 
    return http.get(baseUrl+"/one/nox/",{ params:data })
  }
   
  //汽轮机转速 测试p_id用34  项目id p_id 用户id user_id
  getData.speed= (data)=>{ 
    return http.get(baseUrl+"/one/speed/",{ params:data })
  }
  //中屏主蒸汽流量 测试p_id用34  项目id p_id 用户id user_id
  getData.steamflow= (data)=>{ 
    return http.get(baseUrl+"/one/steamflow/",{ params:data })
  }
  //中屏主蒸汽温度压力 测试p_id用34  项目id p_id 用户id user_id
  getData.steampresstem= (data)=>{ 
    return http.get(baseUrl+"/one/steampresstem/",{ params:data })
  }
  //汽轮机健康指数 测试p_id用34  项目id p_id 用户id user_id
  getData.healthindex= (data)=>{ 
    return http.get(baseUrl+"/one/healthindex/",{ params:data })
  }
  //最近七次补水量 测试p_id用34  项目id p_id 用户id user_id
  getData.recentsteamsupply= (data)=>{ 
    return http.get(baseUrl+"/one/recentsteamsupply/",{ params:data })
  }
  //年月日 测试p_id用34  项目id p_id 用户id user_id
  getData.steamsupply= (data)=>{ 
    return http.get(baseUrl+"/one/steamsupply/",{ params:data })
  }
  //大屏项目Dashboard列表 测试p_id用34  项目id p_id 用户id user_id
  getData.projectdashboardlist= (data)=>{ 
    return http.get(baseUrl+"/one/projectdashboardlist/",{ params:data })
  }
  //报警屏总告警数 测试p_id用34  项目id p_id 用户id user_id
  getData.projectcontrol= (data)=>{ 
    return http.get(baseUrl+"/one/projectcontrol/",{ params:data })
  }
  //报警设备月度报警统计，柱状图和雷达图 测试p_id用34  项目id p_id 用户id user_id
  getData.monthalarm= (data)=>{ 
    return http.get(baseUrl+"/one/monthalarm/",{ params:data })
  }
  //历史报警记录 测试p_id用34  项目id p_id 用户id user_id
  getData.alarmlist= (data)=>{ 
    return http.get(baseUrl+"/one/alarmlist/",{ params:data })
  }
  //安全指标 测试p_id用34  项目id p_id 用户id user_id
  getData.safetyindicator= (data)=>{ 
    return http.get(baseUrl+"/one/safetyindicator/",{ params:data })
  }
  //新建组态
  getData.createdashboard= (data)=>{ 
    return http.get(baseUrl+"/one/createdashboard/",{ params:data })
  }
  //查询组态
  getData.dashboardlist= (data)=>{ 
    return http.get(baseUrl+"/one/dashboardlist/",{ params:data })
  }
  //删除组态
  getData.deletedashboard= (data)=>{ 
    return http.get(baseUrl+"/one/deletedashboard/",{ params:data })
  }
  //大屏项目列表  user_id  
  getData.screenprojectlist= (data)=>{ 
    return http.get(baseUrl+"/one/screenprojectlist/",{ params:data })
  }
export default getData


// WEBPACK FOOTER //
// ./src/common/BigScreen.js